/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import {PackageCategoryInfo} from "types/entities/PackageCategoryEntity";
import clsx from "clsx";

const CategoryDetailInfoCards = (props: {categoryInfo: PackageCategoryInfo}) => {
    const {t} = useTranslation();
    return (
        <section
            className={
            clsx(
                "CategoryDetailInfoCards col-span-12 flex flex-col md:flex-row gap-x-4 md:gap-x-6 lg:gap-x-8 xl:gap-x-12 gap-y-4 md:gap-y-6 lg:gap-y-8 xl:gap-y-12",
                props.categoryInfo.infoValues.length == 0 ? "items-center justify-center" : "items-start justify-between",
                )}
        >
            {props.categoryInfo.infoValues.length > 0 && (
                <div className={"GroupInfo basis-1/2 flex flex-col items-center md:items-start p-4 rounded-2xl bg-white shadow-lg text-gray-600 md:text-lg"}>
                    <h2 className={"font-zuume italic font-black text-5xl md:text-6xl text-black"}>{props.categoryInfo.title}</h2>
                    <div className={"flex flex-col my-4 font-semibold leading-normal"}>{props.categoryInfo.subtitle}</div>
                    <table className="w-full border-separate border-spacing-y-4 text-center sm:text-left">
                        <tbody>
                            {props.categoryInfo.infoValues.map((infoValue, index) => {
                                return (
                                    <tr className={"infoValue flex flex-col sm:table-row my-2"} key={index}>
                                        <td className={"font-semibold leading-normal sm:table-cell"}>{infoValue.key}</td>
                                        <td className={"sm:table-cell"}>{infoValue.value}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            <div className={clsx(
                "GroupInfo basis-1/2 grow flex flex-col ",
                props.categoryInfo.infoValues.length == 0 ? "max-w-3xl items-center": "items-center md:items-start ",
                "p-4 rounded-2xl bg-white shadow-lg text-gray-600 md:text-lg")}>
                <h2 className={"font-zuume italic text-center font-black text-5xl md:text-6xl text-black"}>{t("Info")}</h2>
                <ol className={"flex flex-col mt-4 space-y-4"}>
                    {props.categoryInfo.infoText.map((infoText, index) => {
                        return <li key={index}>{infoText}</li>;
                    })}
                </ol>
            </div>
        </section>
    );
};

export default CategoryDetailInfoCards;
